import React, { Component } from 'react'
import { connect } from 'react-redux'
import css from './index.scss'

const logoPurple = require('../../assets/img/logo-azship-purple.svg')

class Loading extends Component {
  state = {
    isApplicationLoading: false,
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isApplicationLoading !== this.state.isApplicationLoading) {
      this.setState(prevState => ({ isApplicationLoading: !prevState.isApplicationLoading }))
    }
  }

  render() {
    if (!this.state.isApplicationLoading && !this.props.forcedLoading) {
      return null
    }
    return (
      <div className={css.loaderContainer}>
        <img src={logoPurple} alt="logo" className={css.logoLoader} />
        <div className={css.loader} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isApplicationLoading: state.application.isApplicationLoading,
})

export default connect(mapStateToProps)(Loading)
